export const cityQNeutral = {
  50: '#F4F6F8',
  100: '#DFE3E8',
  200: '#C4CDD5',
  300: '#919EAB',
  400: '#637381',
  500: '#454F5B',
  600: '#333D48',
  700: '#212B36',
  800: '#161C24',
  900: '#0B0F19',
  950: '#04060A',
};

export const cityQPrimary = {
  50: '#fef1e6',
  100: '#fde3cc',
  200: '#fbcd99',
  300: '#f9b766',
  400: '#f59633',
  500: '#f27405',
  600: '#d96805',
  700: '#ba5904',
  800: '#914603',
  900: '#733802',
  950: '#4c2502',
};

export const cityQSecondary = {
  50: '#E2E1FA',
  100: '#CFCDFA',
  200: '#B8B5F5',
  300: '#9C98F5',
  400: '#8983EB',
  500: '#746EE0',
  600: '#615CC4',
  700: '#534EA3',
  800: '#3F3C80',
  900: '#302D6B',
  950: '#2A2857',
};

export const cityQError = {
  50: '#FAE1E6',
  100: '#FACDD7',
  200: '#F5B0C0',
  300: '#EB8BA1',
  400: '#E06B86',
  500: '#D64C6B',
  600: '#B83B55',
  700: '#992B41',
  800: '#7A1D2F',
  900: '#5C101D',
  950: '#420611',
};

export const cityQWarning = {
  50: '#FAF0E1',
  100: '#FAE5CD',
  200: '#F5D6B0',
  300: '#EBC18B',
  400: '#E0AD6B',
  500: '#D6994C',
  600: '#B8803B',
  700: '#99672B',
  800: '#7A501D',
  900: '#5C3910',
  950: '#422506',
};

export const cityQInfo = {
  50: '#E1F0FA',
  100: '#CDE5FA',
  200: '#B0D6F5',
  300: '#8BC1EB',
  400: '#6BADE0',
  500: '#4C99D6',
  600: '#3B80B8',
  700: '#2B6799',
  800: '#1D507A',
  900: '#10395C',
  950: '#062542',
};

export const cityQSuccess = {
  50: '#E5FAE1',
  100: '#D2FACD',
  200: '#B6F5B0',
  300: '#94EB8B',
  400: '#75E06B',
  500: '#58D64C',
  600: '#44B83B',
  700: '#33992B',
  800: '#227A1D',
  900: '#135C10',
  950: '#084206',
};